import { ADDITIONAL_PAGE_OPTIONS } from '@vfde-sails/constants';
import { getAtomicId } from './getAtomicId';
import { getFlowTypeFromStorage } from './getFlowTypeFromStorage';
import {
    getGigakombi,
    getGigakombiEligibilityToken,
} from './getGigakombi';
import { getHardwareOnly } from './getHardwareOnly';
import { getInsurance } from './getInsurance';
import { getRestlaufzeit } from './getRestlaufzeit';
import { getSaleschannel } from './getSalesChannel';
import { getSubscriptionId } from './getSubscription';
import { getIsTauschbonusEligible } from './getTauschbonus';
import { getTradeIn } from '../../tradeIn/helpers/getTradeIn';
import { CustomerConfig } from '../../../interfaces/state';

/**
 * Collects the customerConfig
 */
export const getCustomerConfig = (): CustomerConfig => {
    const salesChannel = getSaleschannel();
    const deviceId = window[ADDITIONAL_PAGE_OPTIONS].deviceId;
    const isTradeIn = getTradeIn(salesChannel);
    const isGigakombi = getGigakombi(salesChannel);
    const isTauschbonusEligible = getIsTauschbonusEligible();

    return {
        salesChannel,
        deviceId,
        subscriptionId: getSubscriptionId(salesChannel),
        isGigakombi,
        insurance: getInsurance(),
        isHardwareOnly: getHardwareOnly(),
        isTradeIn,
        isTauschbonus: isTauschbonusEligible && isTradeIn, // Tauschbonus is always activated when device is elibigle and tradein is true
        isTauschbonusEligible,
        atomicId: getAtomicId(),
        isRestlaufzeit: getRestlaufzeit(),
        isGigakombiEligible: isGigakombi && !!getGigakombiEligibilityToken(),
        flowType: getFlowTypeFromStorage(),
    };
};
